<template>
  <div>
    <el-row>
      <!-- <el-col :span="20">
            <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
            <el-form-item label="送货日期：">
                <el-date-picker v-model="searchForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="handleCurrentChange(1)" style="float:right">筛选</el-button>
            </el-form-item>
            </el-form>
        </el-col> -->
      <el-col :span="4">
        <el-button size="medium" @click="changeSell">转换生产</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" stripe border style="margin-top: 20px">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="ORDER_DAY" label="日期"></el-table-column>
        <el-table-column prop="TOTAL_COUNT" label="套餐种类"></el-table-column>
        <el-table-column prop="STATUS" label="状态">
          <template slot-scope="scope">
            <el-tag>{{ showStatus[scope.row.STATUS - 1] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- <el-row>
            <el-col :span="24" style="text-align: right">
                <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount" @current-change="handleCurrentChange"></el-pagination>
            </el-col>
        </el-row> -->
    <el-dialog title="转换销售单" center :visible.sync="changeFormVisible" width="450px">
      <el-form :model="changeForm" ref="changeForm" :rules="rules">
        <el-form-item label="选择日期：" :label-width="formLabelWidth" prop="date" required>
          <el-date-picker v-model="changeForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :clearable="false"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitChange('changeForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import { getFormatDay } from '@/assets/common/common';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        date: getFormatDay(0, '-'),
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      changeFormVisible: false,
      changeForm: {},
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
      },
      formLabelWidth: '100px',
      showStatus: ['创建中', '生产中', '待入库', '已入库'],
    };
  },
  methods: {
    openDetail(row) {
      this.$router.push({ name: 'sellProductsDetail' });
      sessionStorage.setItem('totalId', row.ID);
      sessionStorage.setItem('produceDate', row.ORDER_DAY);
      sessionStorage.setItem('totalStatus', row.STATUS);
    },
    changeSell() {
      this.changeFormVisible = true;
    },
    close() {
      this.changeFormVisible = false;
      this.changeForm = {};
    },
    queryTable(e) {
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: e,
      };
      http.post(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitChange() {
      if (!this.changeForm.date) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '12001',
        OTYPE: 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SEND_DAY: this.changeForm.date,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.changeFormVisible = false;
        this.changeForm = {};
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/totalSellProducts.vue